<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 0 8 9"><path d="M0 0h1.25L6 4.5 1.25 9H0V0z" fill="currentColor"/></svg></template>